
const config = {
  apiKey: "AIzaSyBkyF3iDkn4oj30QNEJ8vsnIF57PY0xki0",
  authDomain: "rps-game-d93c5.firebaseapp.com",
  databaseURL: "https://rps-game-d93c5.firebaseio.com",
  projectId: "rps-game-d93c5",
  storageBucket: "rps-game-d93c5.appspot.com",
  messagingSenderId: "131891175803"
};

export default config;
